<div class="main-container">
  <form [formGroup]="form" novalidate>
    <mat-card appearance="outlined">
      <mat-card-title>TeleGo Mobile App Summary</mat-card-title>
      <mat-card-content>
        <table class="table mt-4">
          <tbody>
          <tr>
            <th><strong>Enabled</strong></th>
            <td>{{ summaryModel.isEnabled | yesno }}</td>
          </tr>
          <tr>
            <th><strong>Username</strong></th>
            <td>{{ summaryModel.username }}</td>
          </tr>
          <tr *ngIf="hasProMessagingModule">
            <th><strong>Phone Number For Text Messages</strong></th>
            <td>
              <app-mat-simple-select
                formControlName="smsNumberId"
                name="smsNumberId"
                [inlineLabel]="true"
                [hideLabel]="true"
                [selectItems]="smsPhoneNumbers"
                [submitted]="submitted"
              ></app-mat-simple-select>
            </td>
          </tr>
          <tr>
            <th><strong>Password</strong></th>
            <td>
              <app-show-hide [value]="summaryModel.password || '&nbsp;'"></app-show-hide>
            </td>
          </tr>
          </tbody>
        </table>

        <div *ngIf="summaryModel.hasPassword">
          <h3>
            Scan the QR code with your mobile device to log into the TeleGo Mobile App. Please note that you must have
            the app downloaded from the App Store or the Google Play Store.
          </h3>
          <img alt="QR Code" src="{{ summaryModel.qrCode }}" />
        </div>
        <mat-card-actions *ngIf="hasProMessagingModule">
          <button
            mat-raised-button
            color="primary"
            matTooltip="Save changes"
            (click)="onSettingsSubmit()"
            [promiseBtn]="buttonSettingsSubmitPromise"
          >
            Save
          </button>
        </mat-card-actions>
      </mat-card-content>
    </mat-card>
  </form>

  <!--<app-card title="Change SoftPhone Password" [collapsed]="true">
    <form [formGroup]="changePasswordForm" novalidate (ngSubmit)="onSubmit()">
      <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="hasError">
        Unable to change password. Please try again later.
      </div>
      <app-mat-password-input formControlName="newPassword"
                              label="New Password" autocomplete="new-password"
                              name="newPassword" [submitted]="submitted"></app-mat-password-input>
      <app-mat-password-input formControlName="confirmPassword"
                              autocomplete="new-password"
                              label="Re-enter New Password" name="confirmPassword" [submitted]="submitted"
                              [customErrors]="{mismatchedFields: 'Passwords do not match'}"></app-mat-password-input>

      <button type="submit" mat-raised-button color="primary" matTooltip="Save changes"
              [promiseBtn]="buttonSubmitPromise">
        Submit
      </button>
    </form>
  </app-card>-->

  <mat-card appearance="outlined">
    <mat-card-title>TeleGo Desktop App</mat-card-title>
    <mat-card-content>
      <div fxLayout="row" style="margin-bottom: 20px">
        <span>
          <a href="https://storage.googleapis.com/telego_public/TeleGo-Desktop-1.0.19.0-x64.msi">Download app for Windows</a>
        </span>
      </div>

      <div fxLayout="row" style="margin-bottom: 20px">
        <span>
          <a href="https://storage.googleapis.com/telego_public/TeleGo-Desktop-1.0.19.0-x86.pkg">Download app for Mac OS (Intel chip)</a>
        </span>
      </div>

      <div fxLayout="row">
        <span>
          <a href="https://storage.googleapis.com/telego_public/TeleGo-Desktop-1.0.19.0-arm64.pkg">Download app for Mac OS (Apple chip)</a>
        </span>
      </div>
    </mat-card-content>
  </mat-card>
</div>
